import { MODULE_PERMISSIONS } from '@auth/module-permissions';
import { useAuth } from '@context/AuthProvider';
import { useMemo } from 'react';

export const usePermission = () => {
  const { currentUser } = useAuth();

  const can = (permission: string | string[]): boolean => {
    if (!currentUser?.member) {
      return false;
    }

    if (currentUser.isSuperAdmin) {
      return true;
    }

    if (Array.isArray(permission)) {
      return permission.some((p) => currentUser.permissions.includes(p));
    }

    return currentUser.permissions.includes(permission);
  };

  const hasAccessToModules = useMemo((): boolean => {
    if (currentUser?.isSuperAdmin) {
      return true;
    }

    if (!currentUser?.permissions || currentUser.permissions.length === 0) {
      return false;
    }

    return MODULE_PERMISSIONS.some((permission) =>
      currentUser.permissions.includes(permission)
    );
  }, [currentUser]);

  return { can, hasAccessToModules };
};
